import { GET_CLASS_TEAMS_SUCCESS, GET_CLASS_TEAMS_REQUEST, GET_SCENARIOS_REQUEST, GET_SCENARIOS_SUCCESS, GET_CLASSES_REQUEST, GET_CLASSES_SUCCESS, GET_TRAINER_GAMES_REQUEST, GET_TRAINER_GAMES_SUCCESS, SET_FAVOURITE_SCENARIO_REQUEST, SET_FAVOURITE_SCENARIO_SUCCESS, GET_SCENARIOS_BY_TYPE_REQUEST, GET_SCENARIOS_BY_TYPE_SUCCESS, CREATE_SESSION_REQUEST, CREATE_SESSION_SUCCESS, CREATE_SESSION_FAILURE, GET_SCENARIO_PREVIEW_REQUEST, GET_SCENARIO_PREVIEW_SUCCESS, START_SESSION_REQUEST, START_SESSION_SUCCESS, START_SESSION_FAILURE, GET_SESSION_REQUEST, GET_SESSION_SUCCESS, GET_BENCHMARK_PORTFOLIO_REQUEST, GET_BENCHMARK_PORTFOLIO_SUCCESS, NEXT_STAGE, PREV_STAGE, SELECT_MENU_ITEM, GET_ALLOCATION_REQUEST, GET_ALLOCATION_SUCCESS, CURRENT_STAGE, NEXT_STAGE_SESSION_REQUEST, NEXT_STAGE_SESSION_SUCCESS, SET_CURRENT_ACTIVE_INSTRUMENT, GET_PORTFOLIO_COMPARE_CHART_REQUEST, GET_PORTFOLIO_COMPARE_CHART_SUCCESS, GET_INSTRUMENTS_RETURNS_CHART_REQUEST, GET_INSTRUMENTS_RETURNS_CHART_SUCCESS, GET_PORTFOLIO_VALUES_CHART_REQUEST, GET_PORTFOLIO_VALUES_CHART_SUCCESS, GET_PORTFOLIO_PERFORMANCE_CHART_REQUEST, GET_PORTFOLIO_PERFORMANCE_CHART_SUCCESS, GET_DAILY_VALUES_CHART_REQUEST, GET_DAILY_VALUES_CHART_SUCCESS, GET_DAILY_RETURNS_CHART_REQUEST, GET_DAILY_RETURNS_CHART_SUCCESS, GET_OVERALL_RETURNS_CHART_REQUEST, GET_OVERALL_RETURNS_CHART_SUCCESS, GET_ANNUAL_PERFORMANCE_CHART_REQUEST, GET_ANNUAL_PERFORMANCE_CHART_SUCCESS, GET_SHARPE_RATIO_COMPARE_CHART_REQUEST, GET_SHARPE_RATIO_COMPARE_CHART_SUCCESS, GET_TRAINER_CLASSES_REQUEST, GET_TRAINER_CLASSES_SUCCESS, PAUSE_SESSION_REQUEST, PAUSE_SESSION_SUCCESS, STOP_SESSION_REQUEST, STOP_SESSION_SUCCESS, SET_GAME_STATUS, UPDATE_ACTIVE_USER_TRAINER, GET_TEAMS_SESSION_SUCCESS, GET_TEAMS_SESSION_REQUEST, UPDATE_ALLOCATIONS_TABLE, CLICKED_ELEMENT_FROM_HEADER, UPDATE_BENCHMARK_LEVERAGE, GET_PORTFOLIO_COMPARE_CHART_PREVIEW_REQUEST, GET_PORTFOLIO_COMPARE_CHART_PREVIEW_SUCCESS, GET_INSTRUMENTS_RETURNS_CHART_PREVIEW_REQUEST, GET_INSTRUMENTS_RETURNS_CHART_PREVIEW_SUCCESS, GET_PORTFOLIO_VALUES_CHART_PREVIEW_REQUEST, GET_PORTFOLIO_VALUES_CHART_PREVIEW_SUCCESS, GET_PORTFOLIO_PERFORMANCE_CHART_PREVIEW_REQUEST, GET_PORTFOLIO_PERFORMANCE_CHART_PREVIEW_SUCCESS, SET_USER_STATUS, CHANGE_USER_STATUS, INITIAL_STATES_REPORT } from './trainer.constants'

const INITIAL_STATE = {
    isLoading: false,
    count: 0,
    results: null,
    pageSize: 10,
    numberOfPages: null,
    errorNext: null,
    messageUpdateWeights: null,
    scenariosCount: 0,
    scenariosResults: null,
    scenariosPageSize: 10,
    scenariosNumberOfPages: null,
    classes: [],
    trainerClasses: [],
    teams: null,
    scenariosNameByProfile: [],
    messageCreateSession: null,
    idScenarioPreview: null,
    nameScenarioPreview: null,
    descriptionScenarioPreview: null,
    profileScenarioPreview: null,
    periodTypeScenarioPreview: null,
    instrumentInformationScenarioPreview: [],
    periodsScenarioPreview: [],
    startSessionErrorMessage: null,
    getSessionResponse: null,
    noOfPeriodsState: null,
    gameStatus: null,
    playingTime: null,
    currentInstrumentForTeam: null,
    currentPeriod: '0',
    currentStage: '0',
    contentBenchmarkPortfolio: [],
    benchmarkTypePortfolioTable: null,
    maxLeveragePortfolioTable: null,
    selectedMenuItem: null,
    nextMenuItem: null,
    period: ["Macro:Background", "Portfolios: Allocations", "Portfolios: Compare", "Macro: Review", "Instruments: Returns", "Portfolios: Values", "Portfolios: Performance"],
    currentMenuStage: null,
    nextMenuStage: null,
    allocationResponse: [],
    statusStartSession: null,
    idCreatedSession: null,
    responseGetPortfolioCompareChart: null,
    responseGetInstrumentsReturnsChart: null,
    responseGetPortfolioValuesChart: null,
    responseGetPortfolioPerformanceChart: null,
    responseGetDailyValuesChart: null,
    responseGetDailyReturnsChart: null,
    responseGetOverallReturnsChart: null,
    responseGetAnnualPerformanceChart: null,
    responseGetSharpeRatioCompareChart: null,
    activeUserTrainer: null,
    updatedTeamId: null,
    statusUser: null,
    responseGetTeamsSession: null,
    updateAllocationTable: false,
    updateBenchmarkLeverage: false,
    clickedElemHeader: false,
    responseGetPortfolioCompareChartPreview: null,
    responseGetInstrumentsReturnsChartPreview: null,
    responseGetPortfolioValuesChartPreview: null,
    responseGetPortfolioPerformanceChartPreview: null,
    isLoadingCreateSession: false,
    changeStatusUser: false
}

export const trainerReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_TRAINER_GAMES_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_TRAINER_GAMES_SUCCESS:
            return {
                ...state,
                isLoading: false,
                count: action.payload.count,
                results: action.payload.results,
                numberOfPages: Math.ceil(action.payload.count / state.pageSize)
            }
        case GET_SCENARIOS_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_SCENARIOS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                scenariosCount: action.payload.count,
                scenariosResults: action.payload.results,
                scenariosNumberOfPages: Math.ceil(action.payload.count / state.scenariosPageSize)
            }
        case GET_CLASSES_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_CLASSES_SUCCESS:
            return {
                ...state,
                isLoading: false,
                classes: action.payload
            }
        case GET_TRAINER_CLASSES_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_TRAINER_CLASSES_SUCCESS:
            return {
                ...state,
                isLoading: false,
                trainerClasses: action.payload
            }
        case GET_CLASS_TEAMS_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_CLASS_TEAMS_SUCCESS:
            return {
                ...state,
                isLoading: true,
                teams: action.payload
            }
        case SET_FAVOURITE_SCENARIO_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case SET_FAVOURITE_SCENARIO_SUCCESS:
            var newScenarioResult = state.scenariosResults
            var newContent = state.scenariosResults.content
            newContent.map((c) => {
                if (c.id === action.payload) {
                    c.is_favourite = !c.is_favourite
                }
                return c.is_favourite
            })
            newScenarioResult.content = newContent
            return {
                ...state,
                isLoading: false,
                scenariosResults: newScenarioResult
            }
        case GET_SCENARIOS_BY_TYPE_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_SCENARIOS_BY_TYPE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                scenariosNameByProfile: action.payload
            }
        case CREATE_SESSION_REQUEST:
            return {
                ...state,
                isLoadingCreateSession: true,
                messageCreateSession: null
            }
        case CREATE_SESSION_SUCCESS:
            return {
                ...state,
                isLoadingCreateSession: false,
                messageCreateSession: action.payload.message,
                idCreatedSession: action.payload.data.id
            }
        case CREATE_SESSION_FAILURE:
            return {
                ...state,
                isLoadingCreateSession: false,
                messageCreateSession: action.payload
            }
        case GET_SCENARIO_PREVIEW_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_SCENARIO_PREVIEW_SUCCESS:
            return {
                ...state,
                isLoading: false,
                idScenarioPreview: action.payload.data.scenario.id,
                nameScenarioPreview: action.payload.data.scenario.scenario_name,
                descriptionScenarioPreview: action.payload.data.scenario.description,
                profileScenarioPreview: action.payload.data.scenario.profile,
                periodTypeScenarioPreview: action.payload.data.scenario.period_type,
                instrumentInformationScenarioPreview: action.payload.data.scenario.instrument_information,
                periodsScenarioPreview: action.payload.data.scenario.periods
            }
        case START_SESSION_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case START_SESSION_SUCCESS:
            return {
                ...state,
                isLoading: false,
                statusStartSession: action.payload.response.status
            }
        case START_SESSION_FAILURE:
            return {
                ...state,
                isLoading: false,
                startSessionErrorMessage: action.payload
            }
        case GET_SESSION_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_SESSION_SUCCESS:
            // set menu key
            var newSelectedMenuItem = state.selectedMenuItem
            var newNextMenuItem = state.nextMenuItem
            if ((action.payload.current_period).toString() === "0") {
                newSelectedMenuItem = (action.payload.current_stage).toString()
                if ((action.payload.current_stage).toString() === "2") {
                    newNextMenuItem = "period_10"
                } else {
                    newNextMenuItem = (action.payload.current_stage + 1).toString()
                }
            } else if (action.payload.current_period > 0) {
                newSelectedMenuItem = "period_" + action.payload.current_period + action.payload.current_stage
                if ((action.payload.current_stage).toString() === "6" && (action.payload.current_period === action.payload.scenario.periods.length)) {
                    newNextMenuItem = "final_0"
                } else if ((action.payload.current_stage).toString() === "6") {
                    newNextMenuItem = "period_" + (parseInt(action.payload.current_period) + 1).toString() + "0"
                } else {
                    newNextMenuItem = "period_" + action.payload.current_period + (parseInt(action.payload.current_stage) + 1).toString()
                }
            } else if (action.payload.current_period === -1) {
                newSelectedMenuItem = "final_" + action.payload.current_stage
                if (action.payload.current_stage < 5) {
                    newNextMenuItem = "final_" + (parseInt(action.payload.current_stage) + 1).toString()
                } else if (action.payload.current_stage === 5) {
                    newNextMenuItem = "empty"
                }
            }

            // current and next stage text           
            var newCurrentStage = state.currentMenuStage
            var newNextStage = state.nextMenuStage
            if (newSelectedMenuItem === "0") {
                newCurrentStage = "Welcome"
                newNextStage = "Description"
            } else if (newSelectedMenuItem === "1") {
                newCurrentStage = "Description"
                newNextStage = "Benchmark and leverage"
            } else if (newSelectedMenuItem === "2") {
                newCurrentStage = "Benchmark and leverage"
                newNextStage = "Macro:Background"
            } else if (newSelectedMenuItem === "final_0") {
                newCurrentStage = "Daily Values"
                newNextStage = "Daily Returns"
            } else if (newSelectedMenuItem === "final_1") {
                newCurrentStage = "Daily Returns"
                newNextStage = "Overall Return"
            } else if (newSelectedMenuItem === "final_2") {
                newCurrentStage = "Overall Return"
                newNextStage = "Annual Performance"
            } else if (newSelectedMenuItem === "final_3") {
                newCurrentStage = "Annual Performance"
                newNextStage = "Sharpe Ratio (compute)"
            } else if (newSelectedMenuItem === "final_4") {
                newCurrentStage = "Sharpe Ratio (compute)"
                newNextStage = "Sharpe Ratio (compare)"
            } else if (newSelectedMenuItem === "final_5") {
                newCurrentStage = "Sharpe Ratio (compare)"
                newNextStage = "End of game"
            } else if (newSelectedMenuItem.charAt(newSelectedMenuItem.length - 1) === "0") {
                newCurrentStage = "Macro:Background"
                newNextStage = "Portfolios: Allocations"
            } else if (newSelectedMenuItem.charAt(newSelectedMenuItem.length - 1) === "1") {
                newCurrentStage = "Portfolios: Allocations"
                newNextStage = "Portfolios: Compare"
            } else if (newSelectedMenuItem.charAt(newSelectedMenuItem.length - 1) === "2") {
                newCurrentStage = "Portfolios: Compare"
                newNextStage = "Macro: Review"
            } else if (newSelectedMenuItem.charAt(newSelectedMenuItem.length - 1) === "3") {
                newCurrentStage = "Macro: Review"
                newNextStage = "Instruments: Returns"
            } else if (newSelectedMenuItem.charAt(newSelectedMenuItem.length - 1) === "4") {
                newCurrentStage = "Instruments: Returns"
                newNextStage = "Portfolios: Values"
            } else if (newSelectedMenuItem.charAt(newSelectedMenuItem.length - 1) === "5") {
                newCurrentStage = "Portfolios: Values"
                newNextStage = "Portfolios: Performance"
            } else if (newSelectedMenuItem.charAt(newSelectedMenuItem.length - 1) === "6" && newSelectedMenuItem.charAt(newSelectedMenuItem.length - 2) === (action.payload.scenario.periods.length).toString()) {
                newCurrentStage = "Portfolios: Performance"
                newNextStage = "Daily Values"
            } else if (newSelectedMenuItem.charAt(newSelectedMenuItem.length - 1) === "6" && newSelectedMenuItem.charAt(newSelectedMenuItem.length - 2) !== (action.payload.scenario.periods.length).toString()) {
                newCurrentStage = "Portfolios: Performance"
                newNextStage = "Macro:Background"
            } else if (newSelectedMenuItem === "empty") {
                newCurrentStage = "Portfolios: Performance"
                newNextStage = "End of game"
            }

            return {
                ...state,
                isLoading: false,
                getSessionResponse: action.payload,
                noOfPeriodsState: action.payload.scenario.periods.length,
                gameStatus: action.payload.state,
                playingTime: action.payload.playing_time,
                currentPeriod: (action.payload.current_period).toString(),
                currentStage: (action.payload.current_stage).toString(),
                selectedMenuItem: newSelectedMenuItem,
                nextMenuItem: newNextMenuItem,
                currentMenuStage: newCurrentStage,
                nextMenuStage: newNextStage,
                currentInstrumentForTeam: (action.payload.scenario.instrument_information[0].instrument.id).toString()
            }
        case GET_BENCHMARK_PORTFOLIO_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_BENCHMARK_PORTFOLIO_SUCCESS:
            return {
                ...state,
                isLoading: false,
                contentBenchmarkPortfolio: action.payload.content,
                benchmarkTypePortfolioTable: action.payload.benchmark_type,
                maxLeveragePortfolioTable: action.payload.max_leverage
            }
        case NEXT_STAGE:
            // set menu key
            if (state.getSessionResponse && state.noOfPeriodsState) {
                var keysMenu = ["0", "1", "2"]
                for (var i = 1; i <= state.noOfPeriodsState; i++) {
                    for (var j = 0; j < state.period.length; j++) {
                        keysMenu.push(`period_${i}${j}`)
                    }
                }
                keysMenu.push('final_0')
                keysMenu.push('final_1')
                keysMenu.push('final_2')
                keysMenu.push('final_3')
                keysMenu.push('final_4')
                keysMenu.push('final_5')
                keysMenu.push("empty")
                var newSelectedMenuItemNext = state.selectedMenuItem
                var newNextMenuItemNext = state.nextMenuItem
                for (var iNext = 0; iNext < keysMenu.length; iNext++) {
                    if (state.selectedMenuItem === keysMenu[iNext] && iNext < keysMenu.length - 1) {
                        newSelectedMenuItemNext = keysMenu[iNext + 1]
                        newNextMenuItemNext = keysMenu[iNext + 2]
                    }
                }
            }

            // current and next stage text
            var newCurrentStageNext = state.currentMenuStage
            var newNextStageNext = state.nextMenuStage
            if (newSelectedMenuItemNext)
                if (newSelectedMenuItemNext === "0") {
                    newCurrentStageNext = "Welcome"
                    newNextStageNext = "Description"
                } else if (newSelectedMenuItemNext === "1") {
                    newCurrentStageNext = "Description"
                    newNextStageNext = "Benchmark and leverage"
                } else if (newSelectedMenuItemNext === "2") {
                    newCurrentStageNext = "Benchmark and leverage"
                    newNextStageNext = "Macro:Background"
                } else if (newSelectedMenuItemNext === "final_0") {
                    newCurrentStageNext = "Daily Values"
                    newNextStageNext = "Daily Returns"
                } else if (newSelectedMenuItemNext === "final_1") {
                    newCurrentStageNext = "Daily Returns"
                    newNextStageNext = "Overall Return"
                } else if (newSelectedMenuItemNext === "final_2") {
                    newCurrentStageNext = "Overall Return"
                    newNextStageNext = "Annual Performance"
                } else if (newSelectedMenuItemNext === "final_3") {
                    newCurrentStageNext = "Annual Performance"
                    newNextStageNext = "Sharpe Ratio (compute)"
                } else if (newSelectedMenuItemNext === "final_4") {
                    newCurrentStageNext = "Sharpe Ratio (compute)"
                    newNextStageNext = "Sharpe Ratio (compare)"
                } else if (newSelectedMenuItemNext === "final_5") {
                    newCurrentStageNext = "Sharpe Ratio (compare)"
                    newNextStageNext = "End of game"
                } else if (newSelectedMenuItemNext.charAt(newSelectedMenuItemNext.length - 1) === "0") {
                    newCurrentStageNext = "Macro:Background"
                    newNextStageNext = "Portfolios: Allocations"
                } else if (newSelectedMenuItemNext.charAt(newSelectedMenuItemNext.length - 1) === "1") {
                    newCurrentStageNext = "Portfolios: Allocations"
                    newNextStageNext = "Portfolios: Compare"
                } else if (newSelectedMenuItemNext.charAt(newSelectedMenuItemNext.length - 1) === "2") {
                    newCurrentStageNext = "Portfolios: Compare"
                    newNextStageNext = "Macro: Review"
                } else if (newSelectedMenuItemNext.charAt(newSelectedMenuItemNext.length - 1) === "3") {
                    newCurrentStageNext = "Macro: Review"
                    newNextStageNext = "Instruments: Returns"
                } else if (newSelectedMenuItemNext.charAt(newSelectedMenuItemNext.length - 1) === "4") {
                    newCurrentStageNext = "Instruments: Returns"
                    newNextStageNext = "Portfolios: Values"
                } else if (newSelectedMenuItemNext.charAt(newSelectedMenuItemNext.length - 1) === "5") {
                    newCurrentStageNext = "Portfolios: Values"
                    newNextStageNext = "Portfolios: Performance"
                } else if (newSelectedMenuItemNext.charAt(newSelectedMenuItemNext.length - 1) === "6" && newSelectedMenuItemNext.charAt(newSelectedMenuItemNext.length - 2) === state.noOfPeriodsState.toString()) {
                    newCurrentStageNext = "Portfolios: Performance"
                    newNextStageNext = "Daily Values"
                } else if (newSelectedMenuItemNext.charAt(newSelectedMenuItemNext.length - 1) === "6" && newSelectedMenuItemNext.charAt(newSelectedMenuItemNext.length - 2) !== state.noOfPeriodsState.toString()) {
                    newCurrentStageNext = "Portfolios: Performance"
                    newNextStageNext = "Macro:Background"
                } else if (newSelectedMenuItemNext === "empty") {
                    newCurrentStageNext = "End of game"
                    newNextStageNext = ""
                }

            return {
                ...state,
                selectedMenuItem: newSelectedMenuItemNext,
                nextMenuItem: newNextMenuItemNext,
                currentMenuStage: newCurrentStageNext,
                nextMenuStage: newNextStageNext
            }
        case PREV_STAGE:
            // set menu key
            if (state.getSessionResponse && state.noOfPeriodsState) {
                var keysMenuPrev = ["0", "1", "2"]
                for (var iPrev = 1; iPrev <= state.noOfPeriodsState; iPrev++) {
                    for (var jPrev = 0; jPrev < state.period.length; jPrev++) {
                        keysMenuPrev.push(`period_${iPrev}${jPrev}`)
                    }
                }
                keysMenuPrev.push('final_0')
                keysMenuPrev.push('final_1')
                keysMenuPrev.push('final_2')
                keysMenuPrev.push('final_3')
                keysMenuPrev.push('final_4')
                keysMenuPrev.push('final_5')
                keysMenuPrev.push("empty")
                var newSelectedMenuItemPrev = state.selectedMenuItem
                var newNextMenuItemPrev = state.nextMenuItem
                for (var k = 0; k < keysMenuPrev.length; k++) {
                    if (state.selectedMenuItem === keysMenuPrev[k] && k >= 1) {
                        newSelectedMenuItemPrev = keysMenuPrev[k - 1]
                        newNextMenuItemPrev = keysMenuPrev[k]
                    }
                }
            }

            // current and next stage text
            var newCurrentStagePrev = state.currentMenuStage
            var newNextStagePrev = state.nextMenuStage
            if (state.selectedMenuItem)
                if (state.selectedMenuItem === "0") {
                    newCurrentStagePrev = "Welcome"
                    newNextStagePrev = "Description"
                } else if (state.selectedMenuItem === "1") {
                    newCurrentStagePrev = "Welcome"
                    newNextStagePrev = "Description"
                } else if (state.selectedMenuItem === "2") {
                    newCurrentStagePrev = "Description"
                    newNextStagePrev = "Benchmark and leverage"
                } else if (state.selectedMenuItem === "final_0") {
                    newCurrentStagePrev = "Portfolios: Performance"
                    newNextStagePrev = "Daily Values"
                } else if (state.selectedMenuItem === "final_1") {
                    newCurrentStagePrev = "Daily Values"
                    newNextStagePrev = "Daily Returns"
                } else if (state.selectedMenuItem === "final_2") {
                    newCurrentStagePrev = "Daily Returns"
                    newNextStagePrev = "Overall Return"
                } else if (state.selectedMenuItem === "final_3") {
                    newCurrentStagePrev = "Overall Return"
                    newNextStagePrev = "Annual Performance"
                } else if (state.selectedMenuItem === "final_4") {
                    newCurrentStagePrev = "Annual Performance"
                    newNextStagePrev = "Sharpe Ratio (compute)"
                } else if (state.selectedMenuItem === "final_5") {
                    newCurrentStagePrev = "Sharpe Ratio (compute)"
                    newNextStagePrev = "Sharpe Ratio (compare)"
                } else if (state.selectedMenuItem.charAt(state.selectedMenuItem.length - 1) === "0" && state.selectedMenuItem.charAt(state.selectedMenuItem.length - 2) === "1") {
                    newCurrentStagePrev = "Benchmark and leverage"
                    newNextStagePrev = "Macro:Background"
                } else if (state.selectedMenuItem.charAt(state.selectedMenuItem.length - 1) === "0" && state.selectedMenuItem.charAt(state.selectedMenuItem.length - 2) !== "1") {
                    newCurrentStagePrev = "Portfolios: Performance"
                    newNextStagePrev = "Macro:Background"
                } else if (state.selectedMenuItem.charAt(state.selectedMenuItem.length - 1) === "1") {
                    newCurrentStagePrev = "Macro:Background"
                    newNextStagePrev = "Portfolios: Allocations"
                } else if (state.selectedMenuItem.charAt(state.selectedMenuItem.length - 1) === "2") {
                    newCurrentStagePrev = "Portfolios: Allocations"
                    newNextStagePrev = "Portfolios: Compare"
                } else if (state.selectedMenuItem.charAt(state.selectedMenuItem.length - 1) === "3") {
                    newCurrentStagePrev = "Portfolios: Compare"
                    newNextStagePrev = "Macro: Review"
                } else if (state.selectedMenuItem.charAt(state.selectedMenuItem.length - 1) === "4") {
                    newCurrentStagePrev = "Macro: Review"
                    newNextStagePrev = "Instruments: Returns"
                } else if (state.selectedMenuItem.charAt(state.selectedMenuItem.length - 1) === "5") {
                    newCurrentStagePrev = "Instruments: Returns"
                    newNextStagePrev = "Portfolios: Values"
                } else if (state.selectedMenuItem.charAt(state.selectedMenuItem.length - 1) === "6") {
                    newCurrentStagePrev = "Portfolios: Values"
                    newNextStagePrev = "Portfolios: Performance"
                } else if (state.selectedMenuItem === "empty") {
                    newCurrentStagePrev = "Sharpe Ratio (compare)"
                    newNextStagePrev = "End of game"
                }

            return {
                ...state,
                selectedMenuItem: newSelectedMenuItemPrev,
                nextMenuItem: newNextMenuItemPrev,
                currentMenuStage: newCurrentStagePrev,
                nextMenuStage: newNextStagePrev
            }
        case SELECT_MENU_ITEM:
            // set menu key
            if (state.getSessionResponse && state.noOfPeriodsState) {
                var keysMenuSelect = ["0", "1", "2"]
                for (var iSel = 1; iSel <= state.noOfPeriodsState; iSel++) {
                    for (var jSel = 0; jSel < state.period.length; jSel++) {
                        keysMenuSelect.push(`period_${iSel}${jSel}`)
                    }
                }
                keysMenuSelect.push('final_0')
                keysMenuSelect.push('final_1')
                keysMenuSelect.push('final_2')
                keysMenuSelect.push('final_3')
                keysMenuSelect.push('final_4')
                keysMenuSelect.push('final_5')
                keysMenuSelect.push("empty")
                var newNextMenuItemSelect = state.nextMenuItem
                for (var c = 0; c < keysMenuSelect.length; c++) {
                    if (action.payload === keysMenuSelect[c] && c < keysMenuSelect.length - 1) {
                        newNextMenuItemSelect = keysMenuSelect[c + 1]
                    }
                }
            }

            // current and next stage text
            var newCurrentStageSelect = state.currentMenuStage
            var newNextStageSelect = state.nextMenuStage
            if (action.payload === "0") {
                newCurrentStageSelect = "Welcome"
                newNextStageSelect = "Description"
            } else if (action.payload === "1") {
                newCurrentStageSelect = "Description"
                newNextStageSelect = "Benchmark and leverage"
            } else if (action.payload === "2") {
                newCurrentStageSelect = "Benchmark and leverage"
                newNextStageSelect = "Macro:Background"
            } else if (action.payload === "final_0") {
                newCurrentStageSelect = "Daily Values"
                newNextStageSelect = "Daily Returns"
            } else if (action.payload === "final_1") {
                newCurrentStageSelect = "Daily Returns"
                newNextStageSelect = "Overall Return"
            } else if (action.payload === "final_2") {
                newCurrentStageSelect = "Overall Return"
                newNextStageSelect = "Annual Performance"
            } else if (action.payload === "final_3") {
                newCurrentStageSelect = "Annual Performance"
                newNextStageSelect = "Sharpe Ratio (compute)"
            } else if (action.payload === "final_4") {
                newCurrentStageSelect = "Sharpe Ratio (compute)"
                newNextStageSelect = "Sharpe Ratio (compare)"
            } else if (action.payload === "final_5") {
                newCurrentStageSelect = "Sharpe Ratio (compare)"
                newNextStageSelect = "End of game"
            } else if (action.payload.charAt(action.payload.length - 1) === "0") {
                newCurrentStageSelect = "Macro:Background"
                newNextStageSelect = "Portfolios: Allocations"
            } else if (action.payload.charAt(action.payload.length - 1) === "1") {
                newCurrentStageSelect = "Portfolios: Allocations"
                newNextStageSelect = "Portfolios: Compare"
            } else if (action.payload.charAt(action.payload.length - 1) === "2") {
                newCurrentStageSelect = "Portfolios: Compare"
                newNextStageSelect = "Macro: Review"
            } else if (action.payload.charAt(action.payload.length - 1) === "3") {
                newCurrentStageSelect = "Macro: Review"
                newNextStageSelect = "Instruments: Returns"
            } else if (action.payload.charAt(action.payload.length - 1) === "4") {
                newCurrentStageSelect = "Instruments: Returns"
                newNextStageSelect = "Portfolios: Values"
            } else if (action.payload.charAt(action.payload.length - 1) === "5") {
                newCurrentStageSelect = "Portfolios: Values"
                newNextStageSelect = "Portfolios: Performance"
            } else if (action.payload.charAt(action.payload.length - 1) === "6" && action.payload.charAt(action.payload.length - 2) === state.noOfPeriodsState.toString()) {
                newCurrentStageSelect = "Portfolios: Performance"
                newNextStageSelect = "Daily Values"
            } else if (action.payload.charAt(action.payload.length - 1) === "6" && action.payload.charAt(action.payload.length - 2) !== state.noOfPeriodsState.toString()) {
                newCurrentStageSelect = "Portfolios: Performance"
                newNextStageSelect = "Macro:Background"
            } else if (action.payload === "empty") {
                newCurrentStageSelect = "End of game"
                newNextStageSelect = ""
            }

            return {
                ...state,
                selectedMenuItem: action.payload,
                nextMenuItem: newNextMenuItemSelect,
                currentMenuStage: newCurrentStageSelect,
                nextMenuStage: newNextStageSelect
            }
        case CURRENT_STAGE:
            // set menu key
            if (state.getSessionResponse && state.noOfPeriodsState) {
                var newSelectedMenuItemCurrent = state.selectedMenuItem
                var newNextMenuItemCurrent = state.nextMenuItem
                if (state.currentPeriod === "0") {
                    newSelectedMenuItemCurrent = state.currentStage
                    if (state.currentStage === "2") {
                        newNextMenuItemCurrent = "period_10"
                    } else {
                        newNextMenuItemCurrent = (parseInt(state.currentStage) + 1).toString()
                    }
                } else if (parseInt(state.currentPeriod) > 0) {
                    newSelectedMenuItemCurrent = "period_" + state.currentPeriod + state.currentStage
                    if (state.currentStage === "6" && (parseInt(state.currentPeriod) === state.noOfPeriodsState)) {
                        newNextMenuItemCurrent = "final_0"
                    } else if (state.currentStage === "6") {
                        newNextMenuItemCurrent = "period_" + (parseInt(state.currentPeriod) + 1).toString() + "0"
                    } else
                        newNextMenuItemCurrent = "period_" + state.currentPeriod + (parseInt(state.currentStage) + 1).toString()
                } else if (parseInt(state.currentPeriod) === -1) {
                    newSelectedMenuItemCurrent = "final_" + state.currentStage
                    if (parseInt(state.currentStage) < 5)
                        newNextMenuItemCurrent = "final_" + (parseInt(state.currentStage) + 1).toString()
                    else if (parseInt(state.currentStage) === 5) {
                        newNextMenuItemCurrent = "empty"
                    }
                }
            }
            // current and next stage text
            var newCurrentStageCurrent = state.currentMenuStage
            var newNextStageCurrent = state.nextMenuStage
            if (newSelectedMenuItemCurrent === "0") {
                newCurrentStageCurrent = "Welcome"
                newNextStageCurrent = "Description"
            } else if (newSelectedMenuItemCurrent === "1") {
                newCurrentStageCurrent = "Description"
                newNextStageCurrent = "Benchmark and leverage"
            } else if (newSelectedMenuItemCurrent === "2") {
                newCurrentStageCurrent = "Benchmark and leverage"
                newNextStageCurrent = "Macro:Background"
            } else if (newSelectedMenuItemCurrent === "final_0") {
                newCurrentStageCurrent = "Daily Values"
                newNextStageCurrent = "Daily Returns"
            } else if (newSelectedMenuItemCurrent === "final_1") {
                newCurrentStageCurrent = "Daily Returns"
                newNextStageCurrent = "Overall Return"
            } else if (newSelectedMenuItemCurrent === "final_2") {
                newCurrentStageCurrent = "Overall Return"
                newNextStageCurrent = "Annual Performance"
            } else if (newSelectedMenuItemCurrent === "final_3") {
                newCurrentStageCurrent = "Annual Performance"
                newNextStageCurrent = "Sharpe Ratio (compute)"
            } else if (newSelectedMenuItemCurrent === "final_4") {
                newCurrentStageCurrent = "Sharpe Ratio (compute)"
                newNextStageCurrent = "Sharpe Ratio (compare)"
            } else if (newSelectedMenuItemCurrent === "final_5") {
                newCurrentStageCurrent = "Sharpe Ratio (compare)"
                newNextStageCurrent = "End of game"
            } else if (newSelectedMenuItemCurrent.charAt(newSelectedMenuItemCurrent.length - 1) === "0") {
                newCurrentStageCurrent = "Macro:Background"
                newNextStageCurrent = "Portfolios: Allocations"
            } else if (newSelectedMenuItemCurrent.charAt(newSelectedMenuItemCurrent.length - 1) === "1") {
                newCurrentStageCurrent = "Portfolios: Allocations"
                newNextStageCurrent = "Portfolios: Compare"
            } else if (newSelectedMenuItemCurrent.charAt(newSelectedMenuItemCurrent.length - 1) === "2") {
                newCurrentStageCurrent = "Portfolios: Compare"
                newNextStageCurrent = "Macro: Review"
            } else if (newSelectedMenuItemCurrent.charAt(newSelectedMenuItemCurrent.length - 1) === "3") {
                newCurrentStageCurrent = "Macro: Review"
                newNextStageCurrent = "Instruments: Returns"
            } else if (newSelectedMenuItemCurrent.charAt(newSelectedMenuItemCurrent.length - 1) === "4") {
                newCurrentStageCurrent = "Instruments: Returns"
                newNextStageCurrent = "Portfolios: Values"
            } else if (newSelectedMenuItemCurrent.charAt(newSelectedMenuItemCurrent.length - 1) === "5") {
                newCurrentStageCurrent = "Portfolios: Values"
                newNextStageCurrent = "Portfolios: Performance"
            } else if (newSelectedMenuItemCurrent.charAt(newSelectedMenuItemCurrent.length - 1) === "6" && newSelectedMenuItemCurrent.charAt(newSelectedMenuItemCurrent.length - 2) === state.noOfPeriodsState.toString()) {
                newCurrentStageCurrent = "Portfolios: Performance"
                newNextStageCurrent = "Daily Values"
            } else if (newSelectedMenuItemCurrent.charAt(newSelectedMenuItemCurrent.length - 1) === "6" && newSelectedMenuItemCurrent.charAt(newSelectedMenuItemCurrent.length - 2) !== state.noOfPeriodsState.toString()) {
                newCurrentStageCurrent = "Portfolios: Performance"
                newNextStageCurrent = "Macro:Background"
            } else if (newSelectedMenuItemCurrent === "empty") {
                newCurrentStageCurrent = "End of game"
                newNextStageCurrent = ""
            }

            return {
                ...state,
                selectedMenuItem: newSelectedMenuItemCurrent,
                nextMenuItem: newNextMenuItemCurrent,
                currentMenuStage: newCurrentStageCurrent,
                nextMenuStage: newNextStageCurrent
            }
        case SET_CURRENT_ACTIVE_INSTRUMENT:
            return {
                ...state,
                currentInstrumentForTeam: action.payload
            }
        case GET_ALLOCATION_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_ALLOCATION_SUCCESS:
            return {
                ...state,
                isLoading: false,
                allocationResponse: action.payload.content
            }
        case NEXT_STAGE_SESSION_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case NEXT_STAGE_SESSION_SUCCESS:
            var periodAux = (JSON.parse(action.payload.config.data).current_period).toString()
            var stageAux = (JSON.parse(action.payload.config.data).current_stage).toString()
            return {
                ...state,
                isLoading: false,
                currentPeriod: periodAux,
                currentStage: stageAux
            }
        case GET_PORTFOLIO_COMPARE_CHART_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_PORTFOLIO_COMPARE_CHART_SUCCESS:
            return {
                ...state,
                isLoading: false,
                responseGetPortfolioCompareChart: action.payload.data
            }
        case GET_INSTRUMENTS_RETURNS_CHART_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_INSTRUMENTS_RETURNS_CHART_SUCCESS:
            return {
                ...state,
                isLoading: false,
                responseGetInstrumentsReturnsChart: action.payload.data
            }
        case GET_PORTFOLIO_VALUES_CHART_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_PORTFOLIO_VALUES_CHART_SUCCESS:
            return {
                ...state,
                isLoading: false,
                responseGetPortfolioValuesChart: action.payload.data
            }
        case GET_PORTFOLIO_PERFORMANCE_CHART_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_PORTFOLIO_PERFORMANCE_CHART_SUCCESS:
            return {
                ...state,
                isLoading: false,
                responseGetPortfolioPerformanceChart: action.payload.data
            }
        case GET_DAILY_VALUES_CHART_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_DAILY_VALUES_CHART_SUCCESS:
            return {
                ...state,
                isLoading: false,
                responseGetDailyValuesChart: action.payload.data
            }
        case GET_DAILY_RETURNS_CHART_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_DAILY_RETURNS_CHART_SUCCESS:
            return {
                ...state,
                isLoading: false,
                responseGetDailyReturnsChart: action.payload.data
            }
        case GET_OVERALL_RETURNS_CHART_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_OVERALL_RETURNS_CHART_SUCCESS:
            return {
                ...state,
                isLoading: false,
                responseGetOverallReturnsChart: action.payload.data
            }
        case GET_ANNUAL_PERFORMANCE_CHART_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_ANNUAL_PERFORMANCE_CHART_SUCCESS:
            return {
                ...state,
                isLoading: false,
                responseGetAnnualPerformanceChart: action.payload.data
            }
        case GET_SHARPE_RATIO_COMPARE_CHART_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_SHARPE_RATIO_COMPARE_CHART_SUCCESS:
            return {
                ...state,
                isLoading: false,
                responseGetSharpeRatioCompareChart: action.payload.data
            }
        case PAUSE_SESSION_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case PAUSE_SESSION_SUCCESS:
            return {
                ...state,
                isLoading: false,
                gameStatus: "PAUSED"
            }
        case STOP_SESSION_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case STOP_SESSION_SUCCESS:
            return {
                ...state,
                isLoading: false,
                gameStatus: "FINISHED"
            }
        case SET_GAME_STATUS:
            return {
                ...state,
                gameStatus: action.payload
            }
        case UPDATE_ACTIVE_USER_TRAINER:
            var auxTeams = null
            if (state.teams && state.teams.teams && state.teams.teams.length > 0) {
                auxTeams = state.teams
                var auxTeamsContent = state.teams.teams
                for (var el = 0; el < auxTeamsContent.length; el++) {
                    if (action.payload.team === auxTeamsContent[el].id) {
                        if (auxTeamsContent[el].personas && auxTeamsContent[el].personas > 0) {
                            auxTeamsContent[el].personas.map((m) => {
                                if (m.name === action.payload.member) {
                                    m.is_active = action.payload.status
                                }
                                return m.is_active
                            })
                        }
                    }
                }
                auxTeams.teams = auxTeamsContent
            }

            return {
                ...state,
                activeUserTrainer: action.payload.member,
                updatedTeamId: action.payload.team,
                statusUser: action.payload.status,
                teams: auxTeams ? auxTeams : state.teams,
                changeStatusUser: !state.changeStatusUser
            }
        case SET_USER_STATUS:
            return {
                ...state,
                statusUser: true
            }
        case GET_TEAMS_SESSION_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_TEAMS_SESSION_SUCCESS:
            return {
                ...state,
                isLoading: false,
                responseGetTeamsSession: action.payload.data
            }
        case UPDATE_ALLOCATIONS_TABLE:
            return {
                ...state,
                updateAllocationTable: !state.updateAllocationTable
            }
        case UPDATE_BENCHMARK_LEVERAGE:
            return {
                ...state,
                updateBenchmarkLeverage: !state.updateBenchmarkLeverage
            }
        case CLICKED_ELEMENT_FROM_HEADER:
            return {
                ...state,
                clickedElemHeader: !state.clickedElemHeader
            }
        case GET_PORTFOLIO_COMPARE_CHART_PREVIEW_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_PORTFOLIO_COMPARE_CHART_PREVIEW_SUCCESS:
            return {
                ...state,
                isLoading: false,
                responseGetPortfolioCompareChartPreview: action.payload.data
            }
        case GET_INSTRUMENTS_RETURNS_CHART_PREVIEW_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_INSTRUMENTS_RETURNS_CHART_PREVIEW_SUCCESS:
            return {
                ...state,
                isLoading: false,
                responseGetInstrumentsReturnsChartPreview: action.payload.data
            }
        case GET_PORTFOLIO_VALUES_CHART_PREVIEW_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_PORTFOLIO_VALUES_CHART_PREVIEW_SUCCESS:
            return {
                ...state,
                isLoading: false,
                responseGetPortfolioValuesChartPreview: action.payload.data
            }
        case GET_PORTFOLIO_PERFORMANCE_CHART_PREVIEW_REQUEST:
            return {
                ...state,
                isLoading: true
            }
        case GET_PORTFOLIO_PERFORMANCE_CHART_PREVIEW_SUCCESS:
            return {
                ...state,
                isLoading: false,
                responseGetPortfolioPerformanceChartPreview: action.payload.data
            }
        case CHANGE_USER_STATUS:
            return {
                ...state,
                changeStatusUser: !state.changeStatusUser
            }
        case INITIAL_STATES_REPORT:
            return {
                ...state,
                selectedMenuItem: "0",
                nextMenuItem: "1",
                nextMenuStage: "Welcome",
                currentMenuStage: "Description"
            }
        default:
            return state
    }
}